module.exports = __webpack_public_path__ + "img/dog_boxer.809ab344.png";